import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/close.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-30" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "fs-18 mb-40 text-title" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ps-0 ls-1"
}
const _hoisted_7 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-title fw-normal fs-14 pt-0 ls-1 text-end pe-0"
}
const _hoisted_13 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph ps-0" }
const _hoisted_14 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_15 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_16 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_17 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_18 = { class: "quantity-cell" }
const _hoisted_19 = {
  key: 0,
  class: "d-block text-danger mt-2"
}
const _hoisted_20 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_21 = { class: "shadow-none lh-1 text-end pe-0" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["alt"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  colspan: "7",
  class: "text-center py-4 text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuantityCounter = _resolveComponent("QuantityCounter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t("transfer_page.selected_products_for_transfer")), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("transfer_page.product")), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("transfer_page.product_code")), 1),
              _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("transfer_page.available_stock")), 1),
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("transfer_page.unit_cost")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("transfer_page.quantity")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("transfer_page.subtotal")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("transfer_page.delete")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.product_id
              }, [
                _createElementVNode("td", _hoisted_13, _toDisplayString(item.product_name), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(item.product_code), 1),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["badge fw-semibold fs-14", item.available_stock > 0 ? 'badge-success-soft' : 'badge-danger-soft'])
                  }, _toDisplayString(item.available_stock), 3)
                ]),
                _createElementVNode("td", _hoisted_16, "$" + _toDisplayString(Number(item.unit_cost || 0).toFixed(2)), 1),
                _createElementVNode("td", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_QuantityCounter, {
                      modelValue: item.qty,
                      "onUpdate:modelValue": ($event: any) => (_ctx.$emit('update-qty', index, $event))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    (item.qty > item.available_stock)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_19, _toDisplayString(_ctx.$t("transfer_page.quantity_exceeds_available_stock")), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_20, "$" + _toDisplayString(Number(item.subtotal || 0).toFixed(2)), 1),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "delete-btn bg-transparent border-0",
                    onClick: ($event: any) => (_ctx.$emit('remove-item', index))
                  }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: _ctx.$t('transfer_page.delete')
                    }, null, 8, _hoisted_23)
                  ], 8, _hoisted_22)
                ])
              ]))
            }), 128)),
            (_ctx.items.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_24, [
                  _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.$t("transfer_page.no_products_selected")), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}